













import { Component, Prop, Vue } from 'vue-property-decorator'
import { Dictionary } from 'vue-router/types/router'
import { Getter, Action, Mutation } from 'vuex-class'

import * as t from '@/types'
import steps from '@/steps'

import variable from '@/components/variable.vue'
import navigation from '@/components/navigation.vue'

@Component({
  components: { variable, navigation },
  async beforeRouteLeave (to: any, from: any, next: () => void) {
    await (this as any).saveData()
    next()
  }
})
export default class Step extends Vue {
  @Prop() protected step!: t.StepDefinition
  private currencySymbol = t.currencySymbol
  private steps: t.StepDefinition[] = Object.values(steps)
  @Mutation private setStepReached!: (step: number) => void
  @Action private saveData!: () => Promise<void>
  @Getter private endReached!: boolean
  @Getter private annualDifference!: number
  updated () {
    this.setFocus()
    this.setStepReached(this.step.index)
  }
  mounted () {
    this.setFocus()
    this.setStepReached(this.step.index)
  }
  setFocus () {
    const $el = this.$el
    Vue.nextTick(() => {
      const inputs = Array.from($el.querySelectorAll('input[type=number]')) as HTMLInputElement[]
      if (window.screen.availWidth < 800) {
        return
      }
      for (const input of inputs) {
        if (input.value === '') {
          input.focus()
          break
        }
      }
    })
  }
}
